<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="$emit('close')">
                <div class="modal-container-ajouter" @click.stop>
                    <div class="modal-header-ajouter">
                        <slot name="title">

                        </slot>
                        <slot name="cross">
                            <v-icon style="float: right; top: 0.3vh;" @click="$emit('close')">mdi-close</v-icon>
                        </slot>
                    </div>

                    <div class="modal-body-ajouter">
                        <v-label>{{ $t("_marque_") }} (*)</v-label>
                        <v-text-field outlined class="inputField" v-model="reponse.marque.value"></v-text-field>
                        <v-label>{{ $t("_modele_") }} (*)</v-label>
                        <v-text-field outlined class="inputField" v-model="reponse.modele.value"></v-text-field>

                        <v-label v-if="type === 'onduleur'">{{ $t("_nb_de_mppt_") }} (*)</v-label>
                        <v-text-field v-if="type === 'onduleur'" outlined class="inputField"
                            v-model="reponse.nbMppt.value"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"></v-text-field>

                        <div v-else class="champs">
                            <div>
                                {{ $t("_puissance_nominale_") }} (*)
                            </div>
                            <div class="input">
                                <v-text-field outlined class="inputFieldModule"
                                    v-model="reponse.puissanceNominale.value" :rules="[numberRule]">
                                </v-text-field>
                                <div class="unit">
                                    Wc
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer-ajouter">
                        <v-btn :disabled="inactive"
                            style="float: right; background-color: #d9d9d9; padding: 1vh; font-size: 1rem"
                            @click="add()">
                            {{ $t('_ajouter_') }}
                        </v-btn>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

export default {

    props: {
        type: {
            required: true,
        },
    },

    data() {
        return {
            reponse: {
                "marque": {
                    "value": "",
                    "required": true,
                },
                "modele": {
                    "value": "",
                    "required": true,
                },
                "nbMppt": {
                    "value": null,
                    "required": false,
                },
                "puissanceNominale": {
                    "value": "",
                    "required": false,
                }
            },
            inactive: true,
        }
    },

    methods: {
        //verifie que value est bien un nombre ( qu'il ne ccontient pas deux virgule ou rien apres la virgule par exemple)
        numberRule(value) {
            if (!value) return true;
            const regex = /^\d+(\.\d+)?$/;
            return regex.test(value) || this.$t("_veuillez_entrer_un_nombre_valide_");
        },
        add() {
            const modeleAjoute = {}
            modeleAjoute.data = {}
            modeleAjoute.data.key = this.reponse.marque.value + '-' + this.reponse.modele.value
            if (this.type === 'onduleur') {
                modeleAjoute.data.mppt_nb = this.reponse.nbMppt.value
            }
            else
                modeleAjoute.data.key = modeleAjoute.data.key + '-' + this.reponse.puissanceNominale.value

            this.$emit('saveModel', modeleAjoute)
        }
    },

    watch: {
        reponse: {
            handler() {
                let activer = true
                for (var champs in this.reponse) {
                    if (this.reponse[champs].required === true && this.reponse[champs].value === "") {
                        activer = false
                    }
                }
                if (this.numberRule(this.reponse.puissanceNominale.value) === this.$t("_veuillez_entrer_un_nombre_valide_"))
                    activer = false
                if (this.type !== 'onduleur' && this.reponse.puissanceNominale.value === "")
                    activer = false
                if (this.type === 'onduleur' && this.reponse.nbMppt.value === null) {
                    activer = false
                }
                this.inactive = !activer
            },
            deep: true
        },
    }

}


</script>

<style scoped>
.modal-container-ajouter {
    width: 40vw;
    height: auto;
    margin: 0px auto;
    padding: 2vh;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    border-radius: 0.25rem;
    position: relative;
    flex-direction: column;
}

.modal-header-ajouter {
    font-weight: bold;
    font-size: 1.5rem;
    color: #212121;
    height: fit-content;
}

.modal-body-ajouter {
    overflow-y: auto;
    overflow-x: hidden;
    margin-top: 1vh;
    padding-bottom: 3.5rem;
}

.modal-body-ajouter .v-label {
    color: black;
    /* font-weight: bold; */
}

.modal-footer-ajouter {
    padding: 16px 16px;
    background-color: white;
    color: white;
    position: absolute;
    width: 100%;
    bottom: 0;
    right: 0;
}

.inputFieldModule ::v-deep .v-input__slot {
    /* background-color: aquamarine; */
    min-height: 2.5rem !important;
    height: fit-content !important;
}

.inputFieldModule ::v-deep .v-text-field__details {
    /* background-color: blue; */
    margin: 0;
    min-height: 0;
}

.inputFieldModule ::v-deep .v-text-field__details {
    /* background-color: blueviolet; */
    margin-bottom: 0 !important;
}


.inputFieldModule {
    /* background-color: blanchedalmond; */
    padding: 0;
    font-weight: normal;
    font-size: 1.1rem;
}

.inputFieldModule ::v-deep .v-messages {
    /* background-color: aqua; */
    min-height: 0;
    /* height: 0; */
}
</style>